import React, { Component } from 'react'
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap'
import PropTypes from 'prop-types'

class GridColumnConfiguration extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      availableColumns: props.availableColumns || [],
      selectedColumns: [],
      draggedItem: null,
      draggedFrom: null,
      draggedIndex: null,
      dropTarget: null,
      dropIndex: null,
      isConfigApplied: false,
      showNotification: false
    }
  }

  static propTypes = {
    onConfigChange: PropTypes.func,
    availableColumns: PropTypes.array,
    projectId: PropTypes.number,
    onSave: PropTypes.func,
    userConfig: PropTypes.object
  }

  componentDidMount() {
    this.applyUserConfig(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const configChanged = JSON.stringify(nextProps.userConfig) !== JSON.stringify(this.props.userConfig)
    const columnsChanged = nextProps.availableColumns !== this.props.availableColumns
    
    if ((configChanged || columnsChanged) && !this.state.isConfigApplied) {
      this.applyUserConfig(nextProps)
    }
  }

  applyUserConfig(props) {
    if (props.availableColumns && props.availableColumns.length > 0) {
      if (props.userConfig && props.userConfig.column_order) {
        console.log('Applying user config:', props.userConfig)
        const orderedColumns = []
        const hiddenColumns = []
        
        props.userConfig.column_order.forEach(colId => {
          const col = props.availableColumns.find(c => c.id === colId)
          if (col) {
            orderedColumns.push(col)
          }
        })
        
        if (props.userConfig.hidden_columns) {
          props.userConfig.hidden_columns.forEach(colId => {
            const col = props.availableColumns.find(c => c.id === colId)
            if (col) {
              hiddenColumns.push(col)
            }
          })
        }
        
        props.availableColumns.forEach(col => {
          if (!orderedColumns.find(c => c.id === col.id) && !hiddenColumns.find(c => c.id === col.id)) {
            orderedColumns.push(col)
          }
        })
        
        console.log('Ordered columns:', orderedColumns.map(c => c.id))
        console.log('Hidden columns:', hiddenColumns.map(c => c.id))
        this.setState({ availableColumns: orderedColumns, selectedColumns: hiddenColumns, isConfigApplied: true })
      } else {
        console.log('No user config, using all available columns')
        this.setState({ availableColumns: props.availableColumns, isConfigApplied: true })
      }
    }
  }

  handleDragStart = (e, item, from, index) => {
    if (item.id === 'no' || item.id === 'status') {
      e.preventDefault()
      return
    }
    this.setState({ draggedItem: item, draggedFrom: from, draggedIndex: index })
    e.dataTransfer.effectAllowed = 'move'
  }

  handleDragOver = (e) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
  }

  handleDragEnter = (to, index, item) => {
    const { draggedItem } = this.state
    if (!draggedItem) return
    if (draggedItem.id === 'no' || draggedItem.id === 'status') return
    
    if (item && item.id === 'no') {
      this.setState({ dropTarget: to, dropIndex: index + 1 })
      return
    }
    if (item && item.id === 'status') {
      this.setState({ dropTarget: to, dropIndex: index })
      return
    }
    
    this.setState({ dropTarget: to, dropIndex: index })
  }

  handleDragLeave = () => {
    this.setState({ dropTarget: null, dropIndex: null })
  }

  handleDrop = (e, to, toIndex, item) => {
    e.preventDefault()
    e.stopPropagation()
    const { draggedItem, draggedFrom, draggedIndex } = this.state
    
    if (!draggedItem) return
    if (draggedItem.id === 'no' || draggedItem.id === 'status') return

    let actualIndex = toIndex
    if (item && item.id === 'no') {
      actualIndex = toIndex + 1
    }

    if (draggedFrom === to) {
      const items = [...this.state[to]]
      items.splice(draggedIndex, 1)
      items.splice(actualIndex > draggedIndex ? actualIndex - 1 : actualIndex, 0, draggedItem)
      this.setState({ 
        [to]: items, 
        draggedItem: null, 
        draggedFrom: null, 
        draggedIndex: null,
        dropTarget: null,
        dropIndex: null
      })
    } else {
      const fromItems = [...this.state[draggedFrom]]
      const toItems = [...this.state[to]]
      fromItems.splice(draggedIndex, 1)
      toItems.splice(actualIndex, 0, draggedItem)
      this.setState({
        [draggedFrom]: fromItems,
        [to]: toItems,
        draggedItem: null,
        draggedFrom: null,
        draggedIndex: null,
        dropTarget: null,
        dropIndex: null
      })
    }
  }

  handleDropOnList = (e, to) => {
    e.preventDefault()
    e.stopPropagation()
    const { draggedItem, draggedFrom, draggedIndex } = this.state
    
    if (!draggedItem) return
    if (draggedItem.id === 'no' || draggedItem.id === 'status') return
    if (draggedFrom === to) return

    const fromItems = [...this.state[draggedFrom]]
    const toItems = [...this.state[to]]
    fromItems.splice(draggedIndex, 1)
    
    if (to === 'availableColumns' && toItems.length > 0 && toItems[toItems.length - 1].id === 'status') {
      toItems.splice(toItems.length - 1, 0, draggedItem)
    } else {
      toItems.push(draggedItem)
    }
    
    this.setState({
      [draggedFrom]: fromItems,
      [to]: toItems,
      draggedItem: null,
      draggedFrom: null,
      draggedIndex: null,
      dropTarget: null,
      dropIndex: null
    })
  }

  moveUp = (list, index) => {
    if (index === 0) return
    const items = [...this.state[list]]
    if (items[index].id === 'no' || items[index].id === 'status') return
    if (items[index - 1].id === 'no') return
    const temp = items[index]
    items[index] = items[index - 1]
    items[index - 1] = temp
    this.setState({ [list]: items })
  }

  moveDown = (list, index) => {
    const items = [...this.state[list]]
    if (index === items.length - 1) return
    if (items[index].id === 'no' || items[index].id === 'status') return
    if (items[index + 1].id === 'status') return
    const temp = items[index]
    items[index] = items[index + 1]
    items[index + 1] = temp
    this.setState({ [list]: items })
  }

  getConfiguration = () => {
    const columns = this.state.availableColumns.map(col => col.id)
    const statusIndex = columns.indexOf('status')
    
    if (statusIndex !== -1 && statusIndex !== columns.length - 1) {
      columns.splice(statusIndex, 1)
      columns.push('status')
    }
    
    return {
      column_order: columns,
      hidden_columns: this.state.selectedColumns.map(col => col.id)
    }
  }

  handleSave = () => {
    const config = this.getConfiguration()
    if (this.props.onSave) {
      this.props.onSave(config)
    }
    this.setState({ showNotification: true })
    setTimeout(() => {
      this.setState({ showNotification: false })
    }, 2500)
  }



  renderColumn = (column, index, listName) => {
    const { draggedItem, draggedFrom, draggedIndex, dropTarget, dropIndex } = this.state
    const isDragging = draggedItem && draggedFrom === listName && draggedIndex === index
    const showDropIndicator = dropTarget === listName && dropIndex === index && !(draggedFrom === listName && draggedIndex === index)
    const showSortButtons = listName === 'availableColumns'
    const isLocked = column.id === 'no' || column.id === 'status'
    
    return (
      <div key={column.id}>
        {showDropIndicator && (
          <div style={{
            height: '3px',
            background: '#20a8d8',
            margin: '4px 0',
            borderRadius: '2px',
            boxShadow: '0 0 8px rgba(32, 168, 216, 0.5)'
          }} />
        )}
        <div
          draggable={!isLocked}
          onDragStart={(e) => this.handleDragStart(e, column, listName, index)}
          onDragOver={(e) => { e.stopPropagation(); this.handleDragOver(e) }}
          onDragEnter={() => this.handleDragEnter(listName, index, column)}
          onDrop={(e) => this.handleDrop(e, listName, index, column)}
          style={{
            padding: '8px 12px',
            margin: '0 0 8px 0',
            background: isLocked ? '#f5f5f5' : '#fff',
            border: '1px solid #ddd',
            borderRadius: '4px',
            cursor: isLocked ? 'not-allowed' : 'move',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            opacity: isDragging ? 0.5 : 1,
            transition: 'opacity 0.2s'
          }}
        >
          <div>
            <i className={isLocked ? 'fa fa-lock' : 'fa fa-bars'} style={{ marginRight: '8px', color: '#999' }} />
            {column.name}
          </div>
          {showSortButtons && !isLocked && (
            <div>
              <Button size="sm" color="link" onClick={() => this.moveUp(listName, index)} disabled={index === 0 || (index > 0 && this.state[listName][index - 1].id === 'no')}>
                <i className="fa fa-arrow-up" />
              </Button>
              <Button size="sm" color="link" onClick={() => this.moveDown(listName, index)} disabled={index === this.state[listName].length - 1 || (index < this.state[listName].length - 1 && this.state[listName][index + 1].id === 'status')}>
                <i className="fa fa-arrow-down" />
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }

  render() {
    const { showNotification } = this.state
    const leftColumnHeight = this.state.availableColumns.length * 48 + 100
    const minHeight = Math.max(leftColumnHeight, 500)
    
    return (
      <div>
        {showNotification && (
          <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: '#4dbd74',
            color: 'white',
            padding: '16px 24px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            animation: 'slideIn 0.3s ease-out'
          }}>
            <i className="fa fa-check-circle" style={{ fontSize: '20px' }} />
            <span style={{ fontWeight: '500' }}>Configuration saved successfully</span>
          </div>
        )}
        <style>{`
          @keyframes slideIn {
            from {
              transform: translateX(400px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}</style>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <h5 style={{ margin: 0 }}>Grid Column Configuration</h5>
          <Button color="primary" onClick={this.handleSave}>
            <i className="fa fa-save" style={{ marginRight: '5px' }} />
            Save Configuration
          </Button>
        </div>
        <Row>
          <Col md={6}>
            <Card>
              <CardHeader>Available Columns</CardHeader>
              <CardBody
                onDragOver={this.handleDragOver}
                onDrop={(e) => this.handleDropOnList(e, 'availableColumns')}
                style={{ minHeight: minHeight + 'px', paddingBottom: '50px' }}
              >
                {this.state.availableColumns.map((col, index) =>
                  this.renderColumn(col, index, 'availableColumns')
                )}
              </CardBody>
            </Card>
          </Col>
          <Col md={6}>
            <Card>
              <CardHeader>Hidden Columns</CardHeader>
              <CardBody
                onDragOver={this.handleDragOver}
                onDrop={(e) => this.handleDropOnList(e, 'selectedColumns')}
                style={{ minHeight: minHeight + 'px', paddingBottom: '50px' }}
              >
                {this.state.selectedColumns.map((col, index) =>
                  this.renderColumn(col, index, 'selectedColumns')
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default GridColumnConfiguration



// WEBPACK FOOTER //
// ./src/components/Projects/GridColumnConfiguration.js